import React from "react";
import styled from "styled-components";
import { Negative, Positive } from "./styles/formatting";
import { DIALECTIC, RESULT } from "../constants";

const PromptContainer = styled.div`
	font-size: 24px;
	font-color: rgba(255, 255, 255, 0.76);
	font-weight: 600;
	line-height: 32px;
	padding: 24px 0;
`;

const Progression = styled.span`
	color: #7986cb;
	font-weight: 900;
	font-size: 110%;
`;

const Prompt = ({ stage, dialectic }) => {
	if (stage === DIALECTIC.CONCEPT) {
		return (
			<PromptContainer>
				What is the big <Positive>IDEA</Positive>?
			</PromptContainer>
		);
	}
	if (stage === DIALECTIC.NEGATION) {
		return (
			<PromptContainer>
				What is not <Positive> {dialectic.concept}</Positive>?
			</PromptContainer>
		);
	}
	if (stage === DIALECTIC.SYNTHESIS) {
		return (
			<PromptContainer>
				What is not <Positive>{dialectic.concept}</Positive> and not{" "}
				<Negative>{dialectic.negation}</Negative>?{" "}
			</PromptContainer>
		);
	}
	if (stage === RESULT) {
		return (
			<PromptContainer>
				<Progression>{dialectic.synthesis}</Progression> is an evolution of{" "}
				<Positive>{dialectic.concept}</Positive>{" "}
			</PromptContainer>
		);
	}
};

export default Prompt;
